import { useCallback, useEffect, useState, useContext } from "react";
import { FilterContext } from "../FilterContextProvider";
import useApi from "../Api/Api";

const useAllEventsFilterDate = (filterOverrides = {}) => {
  const { filterData } = useContext(FilterContext);
  const api = useApi();
  const [allEventsFilterDate, setAllEventsFilterDate] = useState([]);
  const [eventIds, setEventIds] = useState([]);

  const getAllEventsFilterDate = useCallback(() => {
    let queryParams = {};
    if (filterData.artist_id) {
      queryParams.artist_id = filterData.artist_id;
    }
    if (filterData.start_date) {
      queryParams.start_date = filterData.start_date;
    }
    if (filterData.end_date) {
      queryParams.end_date = filterData.end_date;
    }
    if (filterOverrides) {
      queryParams.reporting_type = filterOverrides;
    }
    const queryString = [
      ...Object.keys(queryParams).map((param) => `${param}=${queryParams[param]}`),
      ...Object.keys(eventIds).map((id) => `event_ids[]=${id}`),
    ].join("&");
    filterData.artist_id &&
      api.get(`/events/all?${queryString}`).then((r) => {
        setAllEventsFilterDate(r.data);
      });
  }, [api, filterData, filterOverrides, eventIds]);

  useEffect(() => {
    setAllEventsFilterDate([]);
  }, [filterData]);

  useEffect(() => {
    getAllEventsFilterDate();
  }, [getAllEventsFilterDate]);

  allEventsFilterDate.forEach((event) => {
    const [year, month, day] = event.date.split("T")[0].split("-");
    event.formattedDate = `${month}/${day}/${year}`;
  });

  return {
    allEventsFilterDate,
    getAllEventsFilterDate,
    eventIds,
    setEventIds,
  };
};

export default useAllEventsFilterDate;
